import createFetchDuck from '../../util/genericEntityDuck';

export const storeKey = 'payloads';
const duck = createFetchDuck('HEARTBEAT', storeKey, 'path', 'heartbeat');

export default duck;
export const { creators, reducer, types, selectors } = duck;
